import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, FeatureGuard, NoAuthGuard } from '@clooper/core';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/main-layout/main-layout.module').then(
        (m) => m.MainLayoutModule
      ),
  },
  {
    path: 'login',
    canActivate: [NoAuthGuard],
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'signup',
    canActivate: [NoAuthGuard],
    loadChildren: () =>
      import('./pages/signup/signup.module').then((m) => m.SignupPageModule),
  },
  {
    path: 'onboard',
    canActivate: [NoAuthGuard],
    loadChildren: () =>
      import('./pages/onboard/onboard.module').then((m) => m.OnboardPageModule),
  },
  {
    path: 'listings',
    loadChildren: () =>
      import('./pages/listings/listings.module').then((m) => m.ListingsModule),
  },
  {
    path: 'support-center',
    loadChildren: () =>
      import('./pages/support-center/support-center.module').then((m) => m.SupportCenterPageModule),
  },
  {
    path: 'flights',
    canActivate: [AuthGuard],
    canLoad: [FeatureGuard],
    data: { feature: 'flights' },
    loadChildren: () =>
      import('./pages/flights/flights.module').then((m) => m.FlightsModule),
  },
  {
    path: 'setup',

    loadChildren: () =>
      import('./pages/setup/setup.module').then((m) => m.SetupPagesModule),
  },
  {
    path: 'enquiry-form',
    loadChildren: () =>
      import('./pages/enquiry-form/enquiry-form.module').then(
        (m) => m.EnquiryFormModule
      ),
  },

  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '**',
    loadChildren: () =>
      import('./pages/404/404.module').then((m) => m.PageNotFoundModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabled',
      enableTracing: false,
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
